export const dummyStores = [
  {
    'id': 1,
    'name': 'Savouraki',
    'location':{
      'address': 'Address 1',
      'city': 'Chalkida',
      'zip': '34100',
      'country': 'Greece'
    },
    'phone': '1234567890',
    'email': 'savouraki@gmail.com',
    'open hours': {
      mon: '10:00-22:00',
      tue: '10:00-22:00',
      wed: '10:00-22:00',
      thu: '10:00-22:00',
      fri: '10:00-22:00',
      sat: '10:00-22:00',
      sun: '10:00-22:00'
    },
    'googleMap': 'https://maps.app.goo.gl/gU9cK3TtetT2DJA26',
    'image': 'https://scontent-sof1-2.xx.fbcdn.net/v/t39.30808-6/417419441_908286074631317_6658128434117891932_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=0a03JnIT74wQ7kNvgHY1Hzr&_nc_zt=23&_nc_ht=scontent-sof1-2.xx&_nc_gid=ArPjjX_Ll1_HoVlWq1Ocdp_&oh=00_AYCU1ujoYzFlxS8zg5LWA7EswD6XmovKTBDLLat4DmKMtA&oe=6797057E',
    'menu': [
      {
        'id': 1,
        'name': 'Gyros',
        'price': 5.5,
        'description': 'Gyros with pita, meat, tzatziki, tomato, onion and fries',
        'image': 'https://scontent-sof1-2.xx.fbcdn.net/v/t39.30808-6/417419441_908286074631317_6658128434117891932_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=0a03JnIT74wQ7kNvgHY1Hzr&_nc_zt=23&_nc_ht=scontent-sof1-2.xx&_nc_gid=ArPjjX_Ll1_HoVlWq1Ocdp_&oh=00_AYCU1ujoYzFlxS8zg5LWA7EswD6XmovKTBDLLat4DmKMtA&oe=6797057E',
        'calories': 500,
        'carbs': 50,
        'fat': 20,
        'protein': 30
      },
      {
        'id': 2,
        'name': 'Souvlaki',
        'price': 6.5,
        'description': 'Souvlaki with pita, meat, tzatziki, tomato, onion and fries',
        'image': 'https://scontent-sof1-2.xx.fbcdn.net/v/t39.30808-6/417419441_908286074631317_6658128434117891932_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=0a03JnIT74wQ7kNvgHY1Hzr&_nc_zt=23&_nc_ht=scontent-sof1-2.xx&_nc_gid=ArPjjX_Ll1_HoVlWq1Ocdp_&oh=00_AYCU1ujoYzFlxS8zg5LWA7EswD6XmovKTBDLLat4DmKMtA&oe=6797057E',
        'calories': 600,
        'carbs': 60,
        'fat': 30,
        'protein': 40
      }


    ]
  },
  {
    'id': 2,
    'name': 'Savouraki 2',
    'location':{
      'address': 'Address 1',
      'city': 'Chalkida',
      'zip': '34100',
      'country': 'Greece'
    },
    'phone': '1234567890',
    'email': 'savouraki@gmail.com',
    'open hours': {
      mon: '10:00-22:00',
      tue: '10:00-22:00',
      wed: '10:00-22:00',
      thu: '10:00-22:00',
      fri: '10:00-22:00',
      sat: '10:00-22:00',
      sun: '10:00-22:00'
    },
    'googleMap': 'https://maps.app.goo.gl/gU9cK3TtetT2DJA26',
    'image': 'https://scontent-sof1-2.xx.fbcdn.net/v/t39.30808-6/417419441_908286074631317_6658128434117891932_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=0a03JnIT74wQ7kNvgHY1Hzr&_nc_zt=23&_nc_ht=scontent-sof1-2.xx&_nc_gid=ArPjjX_Ll1_HoVlWq1Ocdp_&oh=00_AYCU1ujoYzFlxS8zg5LWA7EswD6XmovKTBDLLat4DmKMtA&oe=6797057E',
    'menu': [
      {
        'id': 1,
        'name': 'Gyros',
        'price': 5.5,
        'description': 'Gyros with pita, meat, tzatziki, tomato, onion and fries',
        'image': 'https://scontent-sof1-2.xx.fbcdn.net/v/t39.30808-6/417419441_908286074631317_6658128434117891932_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=0a03JnIT74wQ7kNvgHY1Hzr&_nc_zt=23&_nc_ht=scontent-sof1-2.xx&_nc_gid=ArPjjX_Ll1_HoVlWq1Ocdp_&oh=00_AYCU1ujoYzFlxS8zg5LWA7EswD6XmovKTBDLLat4DmKMtA&oe=6797057E',
        'calories': 500,
        'carbs': 50,
        'fat': 20,
        'protein': 30
      },
      {
        'id': 2,
        'name': 'Souvlaki',
        'price': 6.5,
        'description': 'Souvlaki with pita, meat, tzatziki, tomato, onion and fries',
        'image': 'https://scontent-sof1-2.xx.fbcdn.net/v/t39.30808-6/417419441_908286074631317_6658128434117891932_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=0a03JnIT74wQ7kNvgHY1Hzr&_nc_zt=23&_nc_ht=scontent-sof1-2.xx&_nc_gid=ArPjjX_Ll1_HoVlWq1Ocdp_&oh=00_AYCU1ujoYzFlxS8zg5LWA7EswD6XmovKTBDLLat4DmKMtA&oe=6797057E',
        'calories': 600,
        'carbs': 60,
        'fat': 30,
        'protein': 40
      }


    ]
  }
];
export const BASIC_PHOTOS_PATH = 'https://nickport.com/apis/nutriscanner_photos/';

export const defaultOpenHours = [
  { day:'Δευτέρα',itsOpen:true,open: '09:00', close: '17:00' },
  { day:'Τρίτη',itsOpen:true,open: '09:00', close: '17:00' },
  { day:'Τετάρτη',itsOpen:true,open: '09:00', close: '17:00' },
  { day:'Πέμπτη',itsOpen:true,open: '09:00', close: '17:00' },
  { day:'Παρασκευή',itsOpen:true,open: '09:00', close: '17:00' },
  { day:'Σάββατο',itsOpen:true,open: '09:00', close: '17:00' },
  { day:'Κυριακή',itsOpen:true,open: '09:00', close: '17:00' }
];

export const dummyProducts = [
  {
    'id': 1,
    'store_id': 'uyBNznmfiTQIurOjLesm',
    'name': 'Product 1',
    'description': 'Product 1 description',
    'category': 'sandwich',
    'protein' : 150,
    'fat': 200,
    'carbs': 300,
    'calories': 200
  },
  {
    'id': 2,
    'store_id': 'uyBNznmfiTQIurOjLesm',
    'name': 'Product 1',
    'description': 'Product 1 description',
    'category': 'sandwich',
    'protein' : 150,
    'fat': 200,
    'carbs': 300,
    'calories': 200
  },
  {
    'id': 3,
    'store_id': 'uyBNznmfiTQIurOjLesm',
    'name': 'Product 1',
    'description': 'Product 1 description',
    'category': 'sandwich',
    'protein' : 150,
    'fat': 200,
    'carbs': 300,
    'calories': 200
  },
  {
    'id': 4,
    'store_id': 'uyBNznmfiTQIurOjLesm',
    'name': 'Product 1',
    'description': 'Product 1 description',
    'category': 'sandwich',
    'protein' : 150,
    'fat': 200,
    'carbs': 300,
    'calories': 200
  }
  , {
    'id': 5,
    'store_id': 'uyBNznmfiTQIurOjLesm',
    'name': 'Product 1',
    'description': 'Product 1 description',
    'category': 'sandwich',
    'protein' : 150,
    'fat': 200,
    'carbs': 300,
    'calories': 200
  },
  {
    'id': 6,
    'store_id': 'uyBNznmfiTQIurOjLesm',
    'name': 'Product 1',
    'description': 'Product 1 description',
    'category': 'Wrap ',
    'protein' : 150,
    'fat': 200,
    'carbs': 300,
    'calories': 200
  }
];

export const productCategories = [
  {
    value: 'wrap',
    text: 'Αραβική'
  },
  {
    value: 'sandwich',
    text: 'Σαντουιτς'
  },

  {
    value: 'toast',
    text: 'Τοστ'
  },

  {
    value: 'sweet',
    text: 'Γλυκό'
  }
];
